import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { logout, useTypedDispatch, useTypedSelector } from "../../store";
import Button from "../common/Button";
import { twMerge } from "tailwind-merge";

const AuthButton: React.FC<{ className?: string }> = ({ className = "" }) => {
  const { user } = useTypedSelector((state) => state.session);
  const dispatch = useTypedDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  const btnClasses = twMerge(
    classNames(
      "bg-primary p-3 rounded text-white font-semibold flex items-center justify-center text-center",
      className
    )
  );

  if (user?.accessToken) {
    return (
      <Button
        className={btnClasses}
        onClick={handleLogout}
      >
        Se déconnecter
      </Button>
    );
  }

  return (
    <Link to="/auth/login">
      <Button className={btnClasses}>Connexion</Button>
    </Link>
  );
};

export default AuthButton;
